<template>
  <v-hover
    v-slot:default="{ hover }"
  >
    <BaseMyCard
      max-width="350"
      class="mx-4 mb-4"
      :hover="hover"
      height="280"
      max-height="280"
      min-height="280"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <v-img height="150px" :src="course.portada" lazy-src="@/assets/placeholder-image.gif"></v-img>
      <v-card-title class="px-8 mb-1 font-weight-light primary--text">{{ course.titulo }}</v-card-title>
      <v-card-subtitle class="px-8 py-0" style="max-height: 60px; overflow: hidden">
        {{ course.descripcion }}
      </v-card-subtitle>
    </BaseMyCard>
  </v-hover>
</template>

<script>
export default {
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style>
</style>